import { createFileRoute, notFound } from "@tanstack/react-router";

import { DeleteAccountView } from "@/components/pages/DeleteAccountView";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/delete-account")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/delete-account",
          ...meta[params.locale].deleteAccount,
        })
      : {},
  component: DeleteAccountRoute,
});

function DeleteAccountRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <DeleteAccountView locale={locale} />;
}
